/*! Modernizr 3.5.0 | MIT  */

function isTouchDevice() {
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    };
    return false;
}

export default isTouchDevice();